const hasPermission = (requiredPermissions = [], availablePermissions = [], range = 'all') => {
  if (range === 'some') {
    return requiredPermissions.some((permission) => availablePermissions.includes(permission))
  }

  return requiredPermissions.every((permission) => availablePermissions.includes(permission))
}

export default hasPermission
